export default (theme) => {
  return {
    recipient: {
      margin: theme.spacing() / 2,
      maxWidth: 390,
    },
  }
}
